import { InductionOrderCreateRequest } from "~/types/api";

import { customClientBApi } from "./customClientBApi";

export const inductionOrderApi = customClientBApi.injectEndpoints({
  endpoints: (builder) => ({
    createPepsiInductionOrder: builder.mutation<
      void,
      {
        clientId: Guid;
        fulfillmentCenterId: Guid;
      } & InductionOrderCreateRequest
    >({
      query: ({ clientId, fulfillmentCenterId, ...order }) => ({
        url: `/v1/inductionorder`,
        method: "POST",
        params: {
          clientId,
          fulfillmentCenterId
        },
        body: order
      })
    })
  }),
  overrideExisting: false
});
